module.exports = __webpack_public_path__ + "img/auth-back.a31208a3.png";